declare const jQuery: any;
const $ = jQuery;

export function initVideoTiles(): void
{
    const $allOverlays = $(".hs-video-tile.has-overlay .overlay-wrap");
    if ($allOverlays.length === 0)
    {
        return;
    }

    const $allIFrames = $(".hs-video-tile.has-overlay iframe");

    const playIFrame = (iframe: HTMLIFrameElement) => {
        stopAllIFrames(iframe);
        let src: string = iframe['_iw_src_cache'];
        if (!src || (src === "about:blank"))
        {
            src = iframe.src;
        }
        if (src.match(/\bautoplay\=\d/))
        {
            src = src.replace(/\bautoplay\=\d/, "autoplay=1");
        }
        else if (src.match(/\?/))
        {
            src += "&autoplay=1";
        }
        else
        {
            src += "?autoplay=1";
        }
        iframe.src = iframe['_iw_src_cache'] = src;
    };
    
    const stopIFrame = (iframe: HTMLIFrameElement) => {
        if (iframe.src !== 'about:blank')
        {
            iframe['_iw_src_cache'] = iframe.src;
            iframe.src = "about:blank";
        }
    };

    const stopAllIFrames = (exceptIFrame?: HTMLIFrameElement) => {
        const $iframes = exceptIFrame ? $allIFrames.not(exceptIFrame) : $allIFrames;
        $iframes.each(function () {
            stopIFrame(this);
        });
    };

	const hideOverlay = ($overlay) => {
		$overlay.css({ opacity: 0 });
		setTimeout(() => {
			$overlay.css({ display: "none" });
		}, 750);
	};

	const showOverlay = ($overlays) => {
        $overlays.each(function () {
            const $overlay = $(this);
            if ($overlay.css("display") !== "none")
            {
                $overlay.css({ display: "", opacity: 1 });
                return;
            }
            $overlay.css({ display: "", opacity: 0 });
            setTimeout(() => {
                $overlay.css({ opacity: 1 });
            }, 25);
        });
    };
    
    const showAllOverlaysExcerpt = ($overlay?) => {
        const $overlays = $overlay ? $allOverlays.not($overlay) : $allOverlays;
        showOverlay($overlays);
    };

    $allOverlays.each(function () {
        const $overlay = $(this);
        const $iframe = $overlay.closest(".hs-video-tile").find("iframe");
        if ($iframe.length === 0)
        {
            return;
        }
        const iframe = $iframe[0];
        iframe['_iw_src_cache'] = iframe.src;
        iframe.src = "about:blank";
        const play = () => playIFrame(iframe);
        $overlay.click(e => {
            showAllOverlaysExcerpt($overlay);
            hideOverlay($overlay);
			play();
		});
    });
}
